/*@ngInject*/
const UIMultiSelectPopupDirective = function ($rootScope, $document, $window, $timeout, $filter, coreConstant, localization, browserUtil) {

    let linkFunction = function ($scope, $elm) {

        let window = $($window);
        $scope.xPos = 0;
        $scope.yPos = 0;
        $scope.showPopup = false;
        $scope.itemsList = [];
        $scope.showLongListWarning = false;
        $scope.openEvent = null;
        $scope.newHeight = 'auto';
        $scope.longListWarning = {
            originalText: null,
            text: null
        };

        $scope.locationStyle = {
            'left': $scope.xPos,
            'top': $scope.yPos
        };

        $scope.filterText = '';

        localization.getTranslationByKey('advancedFilter').then((translations) => {
            $scope.selectedLabel = translations.selected;
            $scope.clearSelectedLabel = translations.clearSelected;
        });

        localization.getTranslationByKey('formsViewer.controls.dropdown.longListWarning').then((translation) => {
            $scope.longListWarning.originalText = translation
        });

        $scope.$on(coreConstant.event.HIDE_MULTI_SELECT, function () {
            if ($scope.showPopup) {
                $scope.xPos = 0;
                $scope.yPos = 0;
                $scope.showPopup = false;
                $scope.newHeight = 'auto';
                setLocationStyle('visible');
                removeListeners();
                $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_CLOSED, $scope.itemName);
            }
        });

        $scope.$on(coreConstant.event.SHOW_MULTI_SELECT, function (arg1, event, itemsList, itemName) {
            let checkBoxLayer,
                appendToBody = true;

            if (!_.isNil($scope.itemName)) {
                if ($scope.itemName === itemName && $scope.showPopup) {
                    handleDocumentInteraction();
                    return;
                }
                if ($scope.itemName === itemName) {

                    if ($scope.showPopup === false) {
                        addListeners();
                    }
                    $scope.itemName = itemName;
                    $scope.itemsList = itemsList;
                    createdGroupedList();
                    $scope.canClose = false;
                    setLocationStyle('hidden');
                    $scope.showPopup = true;
                    $scope.openEvent = event;
                    positionPopup();

                    $timeout(function () {
                        const inputFilter = $elm.find('.inputFilter');
                        setLocationStyle('visible');
                        inputFilter.focus();
                    }, 0);

                    if (appendToBody) {
                        $document.find('body').append($elm);
                    }
                }
                if ($scope.itemName !== itemName && $scope.showPopup) {
                    checkBoxLayer = $elm.find('.checkboxLayer');
                    $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_CLOSED, $scope.itemName);
                    checkBoxLayer.scrollTop();
                }
            }
        });

        function positionPopup() {
            const event = $scope.openEvent;
            $scope.newHeight = 'auto';
            $timeout(function () {
                const checkBoxLayer = $elm.find('.checkboxLayer'),
                    checkBoxLayerWidth = checkBoxLayer.width(),
                    checkBoxLayerHeight = checkBoxLayer.height(),
                    windowInnerHeight = $window.innerHeight,
                    windowInnerWidth = $window.innerWidth,
                    pageX = event.pageX,
                    pageY = event.pageY,
                    offsetX = (event.offsetX || pageX - $(event.target).offset().left),
                    offsetY = (event.offsetY || pageY - $(event.target).offset().top),
                    targetOffsetHeight = event.target.offsetHeight,
                    targetOffsetTop = event.target.offsetTop;

                if ((pageX - offsetX + checkBoxLayerWidth) > (windowInnerWidth)) {
                    $scope.xPos = windowInnerWidth - checkBoxLayerWidth - 30;
                } else {
                    $scope.xPos = pageX - offsetX;
                }
                if (pageY + checkBoxLayerHeight > (windowInnerHeight)) {
                    $scope.yPos = pageY - offsetY - checkBoxLayerHeight - 15;
                    if ($scope.yPos < 0) {
                        if (windowInnerHeight - (pageY - offsetY + 30) > ((15 + offsetY - pageY) * -1)) {
                            $scope.yPos = pageY - offsetY + 30;
                            $scope.newHeight = windowInnerHeight - $scope.yPos;
                        } else {
                            $scope.yPos = 0;
                            $scope.newHeight = (15 + offsetY - pageY) * -1;
                        }
                    }
                } else {
                    $scope.yPos = pageY - offsetY + targetOffsetHeight;
                    if ($scope.yPos > windowInnerHeight) {
                        $scope.yPos -= targetOffsetTop;
                    }
                }
                $scope.locationStyle = {
                    'left': $scope.xPos,
                    'top': $scope.yPos,
                    'height': $scope.newHeight
                };
            }, 0);
        }

        function setLocationStyle(visibility) {
            $scope.locationStyle = {
                'left': $scope.xPos,
                'top': $scope.yPos,
                'visibility': visibility,
                'height': $scope.newHeight
            };
        }

        $scope.onItemClick = function (item) {
            item.selected = !item.selected;
            $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_UPDATED, $scope.itemName);
        };

        $scope.onFilterChange = function (filterText) {
            if (_.isEmpty(filterText)) {
                $scope.showLongListWarning = false;
            }

            if ($scope.isListLoadDynamically) {
                $scope.isLoading = true;
                $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_FILTER_CHANGED, $scope.itemName, filterText);
            } else {
                createdGroupedList(filterText);
                $timeout(function () {
                    positionPopup();
                }, 0);
            }
        };

        $scope.isSearchListAvailable = function () {
            return !_.isEmpty($scope.filterTextPrompt) && _.isEmpty($scope.groupedItemsList);
        };

        $scope.$on(coreConstant.event.MULTI_SELECT_CLEAR, function () {
            _.each($scope.itemsList, function (item) {
                item.selected = false;
            });
            $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_UPDATED, $scope.itemName);
        });

        $scope.onClearSelected = function () {
            _.each($scope.itemsList, function (item) {
                item.selected = false;
            });
            $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_UPDATED, $scope.itemName);
        };

        $scope.getDescriptionTooltip = function (item) {
            return item.description.length > 42 ? item.description : '';
        };

        function createdGroupedList(filterText) {
            let numberOfFilteredItems = 0;
            $scope.groupedItemsList = {
                selected: {name: $scope.selectedLabel, items: []},
                ungroupedItems: {name: null, items: []}
            };
            _.each($scope.itemsList, function (item) {
                if (_.isNil(filterText) || _.includes(_.lowerCase(item.name), _.lowerCase(filterText))) {
                    //If an item is selected add it to the 'Selected group
                    if (item.selected) {
                        $scope.groupedItemsList.selected.items.push(item);
                        numberOfFilteredItems++;
                        //If an item is in a group, add it to that group
                    } else if (!_.isNil(item.grouping)) {
                        if (_.isNil($scope.groupedItemsList[item.grouping])) {
                            $scope.groupedItemsList[item.grouping] = {name: item.grouping, items: [item]};
                            numberOfFilteredItems++;
                        } else {
                            $scope.groupedItemsList[item.grouping].items.push(item);
                            numberOfFilteredItems++;
                        }
                        //If an item is not selected and has no group, put it in the ungrouped section
                    } else {
                        if (_.isNil($scope.groupedItemsList.ungroupedItems)) {
                            $scope.groupedItemsList.ungroupedItems = {name: null, items: []};
                        }
                        $scope.groupedItemsList.ungroupedItems.items.push(item);
                        numberOfFilteredItems++;
                    }
                }
            });
            $scope.showLongListWarning = numberOfFilteredItems > 500;
            $scope.longListWarning.text = _.replace($scope.longListWarning.originalText, '{0}', $filter('number')(numberOfFilteredItems));
            if ($scope.groupedItemsList.ungroupedItems.items.length === 0) {
                delete $scope.groupedItemsList.ungroupedItems;
            }
            if ($scope.groupedItemsList.selected.items.length === 0) {
                delete $scope.groupedItemsList.selected;
            }
            if ($scope.showLongListWarning) {
                let selected = $scope.groupedItemsList.selected;
                $scope.groupedItemsList = {'selected': selected} ;
            }
        }

        //When we click or scroll in the popup negate our document listeners
        $scope.onPopupClickOrScroll = function () {
            $scope.canClose = false;
            document.removeEventListener('scroll', handleDocumentInteraction, true);
            addDocumentScrollListener();
        };

        // Turn off the document listener while we scroll in the popup
        const addDocumentScrollListener = _.debounce(function () {
            $timeout(function () {
                document.addEventListener('scroll', handleDocumentInteraction, true);
                $scope.canClose = true;
            }, 50);
        }, 50, {trailing: true});

        //Try to close the popup when the user clicks or scrolls outside the popup
        function handleDocumentInteraction() {
            $timeout(function () {
                if ($scope.canClose && $scope.showPopup) {
                    $scope.xPos = 0;
                    $scope.yPos = 0;
                    $scope.showPopup = false;
                    $scope.newHeight = 'auto';
                    setLocationStyle('visible');
                    removeListeners();
                    $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_CLOSED, $scope.itemName);
                }
                $scope.canClose = true;
            }, 0);
        }

        $scope.$on('$destroy', function () {
            const checkBoxLayer = $elm.find('.checkboxLayer');
            checkBoxLayer.remove();
        });

        function addListeners() {
            $document.on('click', handleDocumentInteraction);
            window.on('resize', handleDocumentInteraction);
            $elm.get(0).addEventListener('scroll', $scope.onPopupClickOrScroll, true);
            document.addEventListener('scroll', handleDocumentInteraction, true);
        }

        function removeListeners() {
            $document.off('click', handleDocumentInteraction);
            window.off('resize', handleDocumentInteraction);
            $elm.get(0).removeEventListener('scroll', $scope.onPopupClickOrScroll, true);
            document.removeEventListener('scroll', handleDocumentInteraction, true);
        }

        $scope.$on(coreConstant.event.SHOW_MULTI_SELECT_LIST_UPDATED, function (event, itemsList) {
            $scope.itemsList = [];
            $scope.itemsList = itemsList;
            createdGroupedList();
        });
    };

    return {
        link: linkFunction,
        restrict: 'AE',
        scope: {
            itemName: '<',
            isListLoadDynamically: '<',
            filterTextPrompt: '<'
        },
        templateUrl: '/ui/multiSelect/multiSelectPopup.tpl.html'
    };
};

angular.module('umCore')
    .directive('uiMultiSelectPopup', UIMultiSelectPopupDirective);
